import { useEffect, useState } from 'react';

import getFeatureFlags from 'helpers/getFeatureFlags';
import { legacyRemCss } from 'helpers/legacyRem';

export interface PrintComponentProps {
  firstName: string;
  lastName: string;
  appId: string | number;
  email?: string;
}

export function PrintComponent({ firstName, lastName, appId, email = '' }: PrintComponentProps) {
  const [hasEuServer, setHasEuServer] = useState(false);

  useEffect(() => {
    void getFeatureFlags().then((flags) => {
      setHasEuServer(flags.eu_servers);
    });
  }, []);

  const diplomaUrl = new URL(
    hasEuServer ? `https://eu.crm.travpromobile.com/diploma_api/` : `https://cms.travpromobile.com/api/app/diploma`,
  );
  diplomaUrl.searchParams.append('firstName', firstName);
  diplomaUrl.searchParams.append('lastName', lastName);
  diplomaUrl.searchParams.append('appID', String(appId));
  diplomaUrl.searchParams.append('email', email);

  return (
    <div>
      <div
        style={{
          backgroundColor: '#FFF',
          height: legacyRemCss(80),
          width: 'auto',
          position: 'absolute',
        }}
        id="printCover"
      />
      <img src={diplomaUrl.toString()} alt={`${firstName} ${lastName}`} />
    </div>
  );
}
